module.exports = __webpack_public_path__ + "assets/img/vestamosnoaiq_desconto_black-feed.e25886c0.png";